/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto } from '../models/Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyTransferAgentService {

    /**
     * @returns Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto OK
     * @throws ApiError
     */
    public static getApiCustomerCompanyTransferAgentOptions(): CancelablePromise<Array<Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/company/transfer-agent/options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto OK
     * @throws ApiError
     */
    public static getApiCustomerCompanyTransferAgentCurrent(): CancelablePromise<Wealthlane_CustomerService_AppServices_CompanyService_CompanyTransferAgentDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/company/transfer-agent/current',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
